import { parse, format } from 'date-fns';
import { arSA } from 'date-fns/locale';

// Форматирование времени в h:mm a
export const formatTime = (time: string, lang: string) => {
  return format(parse(time, 'HH:mm:ss', new Date()), 'h:mm a', {
    locale: lang === 'ar' ? arSA : undefined,
  });
};

// Фильтрация слотов, которые уже забронированы
export const filterBookedSlots = (
  availabilityTimes: any[] | undefined,
  alreadyBookedTimes: any[] | undefined,
  selectedDate: string | null,
): any[] => {
  if (!availabilityTimes) return [];

  const ksaOffset = 3;
  const now = new Date();
  const ksaTime = new Date(now.getTime() + (now.getTimezoneOffset() + (ksaOffset * 60)) * 60000);
  const ksaToday = format(ksaTime, 'yyyy-MM-dd');
  const ksaCurrentTimeStr = format(ksaTime, 'HH:mm:ss');

  let filtered = availabilityTimes;

  if (selectedDate === ksaToday) {
    filtered = filtered.filter(slot => slot.start_time > ksaCurrentTimeStr);
  }

  if (!alreadyBookedTimes) return filtered;

  return filtered.filter(slot => {
    return !alreadyBookedTimes.some(booked => {
      const sameDate = booked.date === selectedDate;
      if (!sameDate) return false;

      const slotStart = new Date(`1970-01-01T${slot.start_time}Z`);
      const slotEnd = new Date(`1970-01-01T${slot.end_time}Z`);
      const bookedStart = new Date(`1970-01-01T${booked.start_time}Z`);
      const bookedEnd = new Date(`1970-01-01T${booked.end_time}Z`);

      return (
        (slotStart >= bookedStart && slotStart < bookedEnd) ||
        (slotEnd > bookedStart && slotEnd <= bookedEnd) ||
        (slotStart <= bookedStart && slotEnd >= bookedEnd)
      );
    });
  });
};

// Генерация доступных слотов на основе длительности услуги
export const getAvailableTimes = (availabilityTimes: any[], duration: number): any[] => {
  if (!availabilityTimes) return [];

  const sortedTimes = [...availabilityTimes].sort((a, b) => {
    return (
      new Date(`1970-01-01T${a.start_time}Z`).getTime() -
      new Date(`1970-01-01T${b.start_time}Z`).getTime()
    );
  });

  const result: any[] = [];

  for (let i = 0; i < sortedTimes.length; i++) {
    let totalDuration = 0;
    let startSlot = sortedTimes[i];
    let endSlot = startSlot;

    for (let j = i; j < sortedTimes.length; j++) {
      const currentSlot = sortedTimes[j];
      const startTime = new Date(`1970-01-01T${currentSlot.start_time}Z`);
      const endTime = new Date(`1970-01-01T${currentSlot.end_time}Z`);

      totalDuration += (endTime.getTime() - startTime.getTime()) / (1000 * 60);

      if (totalDuration >= duration) {
        endSlot = currentSlot;
        result.push({ ...startSlot, end_time: endSlot.end_time });
        break;
      }

      const nextStartTime = new Date(`1970-01-01T${sortedTimes[j + 1]?.start_time}Z`);
      if (sortedTimes[j + 1] && nextStartTime.getTime() - endTime.getTime() > 0) break;
    }
  }

  return result;
};

// Filter edge function slots against already booked times in current session
export const filterEdgeFunctionSlots = (
  edgeSlots: Array<{ start: string; end: string }>,
  alreadyBookedTimes: any[] | undefined,
  selectedDate: string | null,
): any[] => {
  // Convert edge function format to internal format
  let convertedSlots = edgeSlots?.map(slot => ({
    start_time: slot.start + ':00', // Add seconds for consistency
    end_time: slot.end + ':00',
  })) || [];

  // Filter out past slots if selected date is today in KSA time (UTC+3)
  const ksaOffset = 3;
  const now = new Date();
  const ksaTime = new Date(now.getTime() + (now.getTimezoneOffset() + (ksaOffset * 60)) * 60000);
  const ksaToday = format(ksaTime, 'yyyy-MM-dd');

  if (selectedDate === ksaToday) {
    const ksaCurrentTimeStr = format(ksaTime, 'HH:mm:ss');
    convertedSlots = convertedSlots.filter(slot => slot.start_time > ksaCurrentTimeStr);
  }

  if (!alreadyBookedTimes || alreadyBookedTimes.length === 0) {
    return convertedSlots;
  }

  // Filter out slots that overlap with already booked times
  return convertedSlots.filter(slot => {
    return !alreadyBookedTimes.some(booked => {
      const sameDate = booked.date === selectedDate;
      if (!sameDate) return false;

      const slotStart = new Date(`1970-01-01T${slot.start_time}Z`);
      const slotEnd = new Date(`1970-01-01T${slot.end_time}Z`);
      const bookedStart = new Date(`1970-01-01T${booked.start_time}Z`);
      const bookedEnd = new Date(`1970-01-01T${booked.end_time}Z`);

      return (
        (slotStart >= bookedStart && slotStart < bookedEnd) ||
        (slotEnd > bookedStart && slotEnd <= bookedEnd) ||
        (slotStart <= bookedStart && slotEnd >= bookedEnd)
      );
    });
  });
};
